export default {
  "nodes": [
    {
      "id": "eef",
      "label": window.backendVars.copy["Energy efficiency"],
      "color": "#2560BD",
      "borderColor": "#164083",
      "x": 63.2734375,
      "y": 521.75,
      "w": 115,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "energy_efficiency"
    },
    {
      "id": "bwc",
      "label": window.backendVars.copy["Bioenergy with CCS"],
      "color": "#FF5C5C",
      "borderColor": "#B52F2F",
      "x": 200.48828125,
      "y": 520.92578125,
      "w": 80,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "bioenergy_css"
    },
    {
      "id": "hwc",
      "label": window.backendVars.copy["Hydrocarbons with CCS"],
      "color": "#FEA857",
      "borderColor": "#E87000",
      "x": 303.60546875,
      "y": 520.05078125,
      "w": 110,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "hydrocarbons_css"
    },
    {
      "id": "nuc",
      "label": window.backendVars.copy["Nuclear"],
      "color": "#FFC352",
      "borderColor": "#D89F2D",
      "x": 440.6640625,
      "y": 519.74609375,
      "w": 65,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "nuclear"
    },
    {
      "id": "hyc",
      "label": window.backendVars.copy["Hydrocarbons"],
      "color": "#A6D594",
      "borderColor": "#5E934B",
      "x": 530.67578125,
      "y": 519.921875,
      "w": 110,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "hydrocarbons"
    },
    {
      "id": "nbr",
      "label": window.backendVars.copy["Non-biomass renewables"],
      "color": "#B583CB",
      "borderColor": "#7C3D98",
      "x": 666.59765625,
      "y": 519.37890625,
      "w": 165,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "nbr"
    },
    {
      "id": "bio",
      "label": window.backendVars.copy["Bioenergy"],
      "color": "#79C3A1",
      "borderColor": "#47A77B",
      "x": 857.66015625,
      "y": 518.98046875,
      "w": 85,
      "h": 80,
      "className": "top-icon inverse",
      "icon": "bioenergy"
    },
    {
      "id": "una",
      "label": window.backendVars.copy["Unassigned"],
      "color": "transparent",
      "x": 24,
      "y": 230,
      "w": 86,
      "h": 28
    },
    {
      "id": "tra",
      "label": window.backendVars.copy["Transport"],
      "color": "transparent",
      "x": 144.0078125,
      "y": 230.3671875,
      "w": 120,
      "h": 28,
      "icon": "transports"
    },
    {
      "id": "rnc",
      "label": window.backendVars.copy["Res & comm"],
      "color": "transparent",
      "x": 305.24609375,
      "y": 230.09765625,
      "w": 120,
      "h": 28,
      "icon": "res_and_comm"
    },
    {
      "id": "ind",
      "label": window.backendVars.copy["Industrial"],
      "color": "transparent",
      "x": 491.37109375,
      "y": 226.52734375,
      "w": 120,
      "h": 28,
      "icon": "industrial"
    },
    {
      "id": "ele",
      "label": window.backendVars.copy["Electricity"],
      "color": "transparent",
      "outColor": "#FF7876",
      "x": 744.84375,
      "y": 376.828125,
      "w": 125,
      "h": 28,
      "icon": "electricity",
      "CO2outDim": "h"
    },
    {
      "id": "geo",
      "label": window.backendVars.copy["Geo storage"],
      "color": "transparent",
      "x": 980.87890625,
      "y": 134.859375,
      "w": 126,
      "h": 28,
      "icon": "geo_storage"
    },
    {
      "id": "nas",
      "label": window.backendVars.copy["Natural sinks"],
      "color": "transparent",
      "x": 1090,
      "y": 300,
      "w": 140,
      "h": 28,
      "icon": "natural_net_sink"
    },
    {
      "id": "nes",
      "label": window.backendVars.copy["Net sinks"],
      "color": "transparent",
      "x": 960.92578125,
      "y": 408.078125,
      "w": 170,
      "h": 30,
      "icon": "net_sinks",
      "editable": true,
      "editableRel": "nas-nes",
      "editableMax": "_maxNes",
      "editableMin": "_minNes",
      "editableMessage": window.backendVars.copy["By managing natural sinks, we can increase the carbon stored to further lower net CO₂ to the atmosphere."]
    },
    {
      "id": "pho",
      "label": window.backendVars.copy["Photosynthesis"],
      "color": "transparent",
      "x": 1090,
      "y": 200,
      "w": 140,
      "h": 28,
      "icon": "photosynthesis"
    },
    {
      "id": "reu",
      "label": window.backendVars.copy["Reuse"],
      "color": "transparent",
      "x": 603,
      "y": 133,
      "w": 180,
      "h": 30,
      "icon": "reuse",
      "editable": true,
      "editableRel": "cac-reu",
      "editableMin": 0,
      "editableMax": "_capture",
      "editableMessage": window.backendVars.copy["Reuse takes CO₂ that would be stored geologically and instead creates economic value by converting it to a product or fuel.  Reuse technologies are expected to be much more affordable by 2050."]
    },
    {
      "id": "cac",
      "label": window.backendVars.copy["Carbon capture"],
      "color": "transparent",
      "x": 812,
      "y": 134,
      "w": 140,
      "h": 30,
      "icon": "carbon_capture"
    },
    {
      "id": "dac",
      "label": window.backendVars.copy["DAC"],
      "color": "transparent",
      "x": 895,
      "y": 228,
      "w": 165,
      "h": 30,
      "icon": "dac",
      "editable": true,
      "editableRel": "dac-geo",
      "editableMin": 0,
      "editableMax": "_maxDac",
      "editableMessage": window.backendVars.copy["Direct Air Capture (DAC) is a new technology. Right now, the cost per ton CO₂ is $500 - $1000. By 2050, it is expected to be less than $100 per ton. Dialing up DAC directly reduces CO₂ from the atmosphere."]
    },
    {
      "id": "nta",
      "label": window.backendVars.copy["Net CO2 to the Atmosphere"],
      "color": "#fff",
      "x": 25,
      "y": 17,
      "w": 125,
      "h": 80,
      "className": "top-icon",
      "icon": "nta",
      "CO2inDim": "h",
      "tooltip": window.backendVars.copy["The Visualizer only shows CO₂ emissions.  Other greenhouse gases (GHGs) contribute to climate change.  Some scenarios result in a net negative CO₂ to the atmosphere by 2050 to balance other GHG emissions."]
    },
    {
      "id": "atm",
      "label": window.backendVars.copy["Atmosphere"],
      "color": "#fff",
      "x": 372.75390625,
      "y": 17.76171875,
      "w": 95,
      "h": 80,
      "className": "top-icon",
      "icon": "atmosphere",
      "CO2outDim": "h"
    }
  ],
  "connectors": [
    {
      "rel": "nuc-ind",
      "series": {
        "data": [
          [
            11.8801,
            14.4683,
            16.574,
            14.4683,
            11.83,
            9.7529
          ],
          [
            40.3855,
            53.2512,
            65.9129,
            75.6692,
            81.0516,
            84.6079
          ],
          [
            18.0463,
            21.8293,
            24.8461,
            20.3875,
            16.6299,
            13.8358
          ],
          [
            11.1042,
            13.8116,
            16.6786,
            19.4298,
            21.435,
            22.6366
          ],
          [
            10.6125,
            13.6381,
            17.1623,
            20.345,
            22.3949,
            23.4571
          ]
        ],
        "r": [
          [
            12.5,
            12.5,
            12.5,
            12.5,
            12.5,
            12.5
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            66.5,
            66.5,
            66.5,
            66.5,
            66.5,
            66.5
          ],
          [
            70.5,
            70.5,
            70.5,
            70.5,
            70.5,
            70.5
          ],
          [
            60.5,
            60.5,
            60.5,
            60.5,
            60.5,
            60.5
          ],
          [
            57,
            57,
            57,
            57,
            57,
            57
          ],
          [
            94.5,
            94.5,
            94.5,
            94.5,
            94.5,
            94.5
          ]
        ]
      }
    },
    {
      "rel": "nuc-ele",
      "series": {
        "data": [
          [
            11.8801,
            14.1552,
            16.574,
            14.4683,
            11.83,
            9.7529
          ],
          [
            40.3855,
            53.2512,
            65.9129,
            75.6692,
            81.0516,
            84.6079
          ],
          [
            18.0463,
            21.8293,
            24.8461,
            20.3875,
            16.6299,
            13.8358
          ],
          [
            11.1042,
            13.8116,
            16.6786,
            19.4298,
            21.435,
            22.6366
          ],
          [
            10.6125,
            13.6381,
            17.1623,
            20.345,
            22.3949,
            23.4571
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            87.5,
            87.5,
            87.5,
            87.5,
            87.5,
            87.5
          ],
          [
            78,
            78,
            78,
            78,
            78,
            78
          ],
          [
            82.5,
            82.5,
            82.5,
            82.5,
            82.5,
            82.5
          ],
          [
            54,
            54,
            54,
            54,
            54,
            54
          ],
          [
            27,
            27,
            31.5,
            35,
            35,
            35
          ]
        ]
      }
    },
    {
      "rel": "hwc-una",
      "series": {
        "data": [
          [
            4.2577,
            11.9079,
            20.0266,
            22.935,
            24.2604,
            22.6546
          ],
          [
            4.1643,
            7.5989,
            12.1791,
            17.2017,
            20.1253,
            21.1819
          ],
          [
            0,
            5.1677,
            13.5866,
            28.223,
            51.0386,
            85.2548
          ],
          [
            0.1074,
            0.3128,
            0.5858,
            0.8198,
            1.0894,
            1.5743
          ],
          [
            1.2175,
            6.7338,
            18.1815,
            28.8902,
            32.7039,
            32.4499
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            4,
            4,
            4,
            4,
            4,
            4
          ],
          [
            23,
            23,
            23,
            23,
            23,
            22.5
          ],
          [
            7.5,
            7.5,
            7.5,
            7.5,
            7.5,
            7.5
          ],
          [
            7.5,
            7.5,
            12,
            12,
            12,
            1
          ],
          [
            5,
            5,
            5,
            5,
            5,
            5
          ]
        ]
      }
    },
    {
      "rel": "hwc-ele",
      "series": {
        "data": [
          [
            1.511,
            4.1406,
            6.4801,
            7.8904,
            10.5408,
            12.4431
          ],
          [
            0.2487,
            2.649,
            7.743,
            11.3543,
            12.412,
            12.2145
          ],
          [
            0,
            4.0419,
            7.7003,
            14.4827,
            26.4965,
            48.5998
          ],
          [
            0.2246,
            0.8112,
            1.797,
            2.808,
            3.5094,
            3.8198
          ],
          [
            0.0607,
            0.275,
            0.5958,
            0.8205,
            0.8732,
            0.8571
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            80.5,
            80.5,
            80.5,
            80.5,
            80.5,
            80.5
          ],
          [
            42.5,
            43,
            43,
            43,
            43,
            43
          ],
          [
            54.5,
            54.5,
            54.5,
            54.5,
            54.5,
            54.5
          ],
          [
            25.5,
            25.5,
            25.5,
            25.5,
            25.5,
            25.5
          ],
          [
            32.5,
            32.5,
            32.5,
            32.5,
            32.5,
            32.5
          ]
        ]
      }
    },
    {
      "rel": "bwc-una",
      "series": {
        "data": [
          [
            1.0200992e-7,
            2.33091e-7,
            1.0817017e-7,
            2.33091e-7,
            7.38205e-7,
            0.000239364
          ],
          [
            0.020396744,
            0.081901797,
            0.20056104,
            0.403910783,
            0.568165411,
            0.694095003
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            4.1949,
            16.001,
            42.0412,
            77.776,
            109.5382,
            131.9445
          ],
          [
            2.6421,
            15.0675,
            39.6779,
            59.433,
            69.0653,
            78.9416
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            19,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            6.5,
            6.5,
            6.5,
            6.5,
            6.5,
            6.5
          ],
          [
            5,
            5,
            5,
            5,
            5,
            5
          ],
          [
            26.5,
            26.5,
            26.5,
            26.5,
            26.5,
            26.5
          ],
          [
            9.5,
            5.5,
            4,
            9.5,
            9.5,
            9.5
          ],
          [
            18,
            18,
            18,
            18,
            22,
            24.5
          ]
        ]
      }
    },
    {
      "rel": "bwc-ele",
      "series": {
        "data": [
          [
            5.32899e-10,
            9.82804e-8,
            2.85823e-8,
            9.82804e-8,
            3.97672e-7,
            0.000124563
          ],
          [
            0.000417,
            0.049792,
            0.287597,
            0.542749,
            0.761311,
            0.991964
          ],
          [
            0,
            0.0543,
            2.0378,
            7.046,
            14.1162,
            21.6418
          ],
          [
            0.2585,
            0.8141,
            1.6983,
            2.6137,
            3.0503,
            3.0375
          ],
          [
            0.0113,
            0.0226,
            0.0225,
            0.0223,
            0.0218,
            0.0208
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            52.5,
            52.5,
            52.5,
            52.5,
            52.5,
            52.5
          ],
          [
            34.5,
            38.5,
            38.5,
            38.5,
            38.5,
            38.5
          ],
          [
            43,
            43,
            43,
            43,
            43,
            43
          ],
          [
            14.5,
            14.5,
            14.5,
            14.5,
            14.5,
            14.5
          ],
          [
            30.5,
            30.5,
            30.5,
            30.5,
            30.5,
            30.5
          ]
        ]
      }
    },
    {
      "rel": "nbr-una",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            13.0817,
            22.2663,
            33.0906,
            44.0268,
            52.3846,
            59.7006
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            4.3093,
            12.5394,
            25.0604,
            39.0155,
            53.2017,
            67.1315
          ],
          [
            2.0131,
            10.3541,
            28.3658,
            49.7554,
            69.2887,
            86.0289
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            13,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            15,
            15,
            15,
            15,
            15,
            15
          ],
          [
            8.5,
            8.5,
            8.5,
            8.5,
            8.5,
            8.5
          ],
          [
            32,
            28.5,
            28.5,
            28.5,
            28.5,
            28.5
          ],
          [
            9,
            9,
            9,
            9,
            9,
            9
          ],
          [
            11,
            11,
            11,
            11,
            12.5,
            13.5
          ]
        ]
      }
    },
    {
      "rel": "nbr-ele",
      "series": {
        "data": [
          [
            26.6866,
            35.19472,
            61.316,
            89.3969,
            112.7411,
            136.4028
          ],
          [
            36.5535,
            50.7575,
            65.2466,
            78.0555,
            88.5447,
            97.3525
          ],
          [
            26.5434,
            68.0133,
            144.5072,
            156.0671,
            152.708,
            141.4955
          ],
          [
            62.2157,
            101.8731,
            145.0458,
            187.4365,
            226.5983,
            261.3593
          ],
          [
            48.8417,
            92.6419,
            152.3352,
            215.7614,
            273.3366,
            323.907
          ]
        ],
        "r": [
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            23.5,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            29.5,
            29.5,
            29.5,
            29.5,
            29.5,
            29.5
          ],
          [
            15,
            15,
            15,
            15,
            15,
            15
          ],
          [
            7.5,
            7.5,
            7.5,
            7.5,
            7.5,
            7.5
          ],
          [
            24.5,
            24.5,
            24.5,
            24.5,
            24.5,
            24.5
          ],
          [
            43,
            43,
            43,
            43,
            43,
            43
          ]
        ]
      }
    },
    {
      "rel": "eef-tra",
      "series": {
        "data": [
          [
            50.9899,
            75.418,
            96.133,
            113.9385,
            123.2891,
            130.6836
          ],
          [
            19.5138,
            32.5314,
            46.4411,
            63.0994,
            77.9662,
            92.1892
          ],
          [
            12.8177,
            34.1673,
            36.2038,
            34.677,
            31.6346,
            27.5561
          ],
          [
            22.1149,
            51.2099,
            37.3425,
            45.0731,
            51.223,
            57.5642
          ],
          [
            20.2209,
            66.0621,
            70.4551,
            80.4272,
            90.7881,
            96.2361
          ]
        ],
        "r": [
          [
            73,
            73,
            73,
            73,
            73,
            73
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            70,
            71.5,
            74,
            77,
            78,
            79
          ],
          [
            53.5,
            53.5,
            53.5,
            53.5,
            53.5,
            53.5
          ],
          [
            77.5,
            77.5,
            77.5,
            77.5,
            77.5,
            77.5
          ],
          [
            63.5,
            70,
            64,
            63.5,
            63.5,
            63.5
          ],
          [
            70,
            70,
            70,
            69,
            70,
            70
          ]
        ]
      }
    },
    {
      "rel": "eef-rnc",
      "series": {
        "data": [
          [
            29.2281,
            44.3341,
            57.482,
            68.6152,
            79.4715,
            90.3554
          ],
          [
            10.7662,
            20.8297,
            30.6055,
            39.844,
            49.9553,
            59.9054
          ],
          [
            16.8414,
            61.5845,
            46.7832,
            48.0237,
            47.6976,
            45.5158
          ],
          [
            46.6825,
            79.7109,
            51.523,
            46.0078,
            41.2326,
            38.8135
          ],
          [
            43.9322,
            92.7415,
            69.5415,
            62.7594,
            54.6394,
            51.184
          ]
        ],
        "r": [
          [
            39.5,
            45.5,
            45.5,
            45.5,
            45.5,
            45
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            64.5,
            64.5,
            64.5,
            64,
            64,
            64.5
          ],
          [
            42,
            42,
            42,
            42,
            42,
            42
          ],
          [
            72,
            72,
            72,
            72,
            72,
            72
          ],
          [
            57,
            61,
            57,
            57,
            56,
            56.5
          ],
          [
            59.5,
            59.5,
            59.5,
            59.5,
            59.5,
            59.5
          ]
        ]
      }
    },
    {
      "rel": "eef-ind",
      "series": {
        "data": [
          [
            30.2787,
            46.8823,
            60.7628,
            72.9728,
            81.6908,
            91.7372
          ],
          [
            10.883,
            22.8632,
            33.3126,
            43.6194,
            52.3306,
            61.1704
          ],
          [
            22.4504,
            62.4652,
            56.576,
            56.19,
            53.6622,
            48.7309
          ],
          [
            69.3253,
            101.4789,
            69.7301,
            64.957,
            61.57,
            62.6128
          ],
          [
            59.5155,
            123.4163,
            105.9929,
            100.4199,
            88.6162,
            80.0191
          ]
        ],
        "r": [
          [
            28,
            28,
            28,
            28,
            28,
            28
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            59,
            56.5,
            55,
            53.5,
            51.5,
            51
          ],
          [
            32,
            32,
            32,
            32,
            32,
            32
          ],
          [
            64.5,
            64.5,
            64.5,
            64.5,
            64.5,
            64.5
          ],
          [
            47.5,
            47.5,
            47.5,
            47.5,
            47.5,
            47.5
          ],
          [
            50,
            45,
            47.5,
            48,
            49,
            50
          ]
        ]
      }
    },
    {
      "rel": "hyc-tra",
      "series": {
        "data": [
          [
            79.5048,
            62.3849,
            44.6318,
            31.2234,
            21.3621,
            15.7929
          ],
          [
            103.4951,
            92.8084,
            79.3109,
            64.1401,
            50.958,
            39.4421
          ],
          [
            91.3549,
            78.421,
            58.1307,
            56.6039,
            58.4226,
            59.9545
          ],
          [
            103.2533,
            97.817,
            95.0627,
            83.6112,
            74.6818,
            66.7893
          ],
          [
            110.2137,
            88.2887,
            68.3132,
            56.8403,
            47.8673,
            45.4522
          ]
        ],
        "r": [
          [
            47.5,
            47.5,
            47.5,
            47.5,
            47.5,
            47.5
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            30,
            30,
            30,
            30,
            30,
            30
          ],
          [
            50.5,
            50.5,
            50.5,
            50.5,
            50.5,
            50.5
          ],
          [
            44,
            44,
            44,
            44,
            44,
            44
          ],
          [
            32,
            27.5,
            30.5,
            32,
            32,
            32
          ],
          [
            34,
            32.5,
            31,
            34.5,
            34.5,
            35
          ]
        ]
      }
    },
    {
      "rel": "hyc-rnc",
      "series": {
        "data": [
          [
            46.6613,
            43.7866,
            40.2074,
            35.1631,
            30.3129,
            26.4027
          ],
          [
            48.699,
            44.7861,
            40.8524,
            38.1643,
            36.2123,
            34.9757
          ],
          [
            78.8142,
            59.3954,
            40.2786,
            42.7396,
            47.8919,
            53.8957
          ],
          [
            38.2135,
            35.9241,
            34.6374,
            35.5732,
            36.6201,
            37.174
          ],
          [
            37.0811,
            25.7688,
            20.2151,
            20.0474,
            21.8049,
            22.5644
          ]
        ],
        "r": [
          [
            21.5,
            21.5,
            21.5,
            21.5,
            21.5,
            21.5
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            43.5,
            43.5,
            43.5,
            43.5,
            43.5,
            43.5
          ],
          [
            61.5,
            61.5,
            59.5,
            58.5,
            57.5,
            56.5
          ],
          [
            55,
            55,
            55,
            55,
            55,
            55
          ],
          [
            40.5,
            38,
            40.5,
            40.5,
            40.5,
            40.5
          ],
          [
            44,
            41.5,
            37.5,
            40,
            40,
            40
          ]
        ]
      }
    },
    {
      "rel": "hyc-ind",
      "series": {
        "data": [
          [
            67.9719,
            61.8026,
            54.1053,
            45.0398,
            38.3721,
            32.7437
          ],
          [
            81.0695,
            76.7156,
            73.6782,
            70.3938,
            69.1232,
            68.0739
          ],
          [
            98.9853,
            74.2024,
            49.0196,
            51.8921,
            58.2953,
            65.1682
          ],
          [
            86.0089,
            88.4276,
            89.0687,
            94.8153,
            96.0731,
            95.6811
          ],
          [
            99.9073,
            72.4513,
            54.6746,
            51.2536,
            51.6657,
            51.9463
          ]
        ],
        "r": [
          [
            15,
            15,
            15,
            15,
            15,
            15
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            9.5
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            60.5,
            60.5,
            60.5,
            60.5,
            60.5,
            60.5
          ],
          [
            70.5,
            70.5,
            67.5,
            66,
            64.5,
            63.5
          ],
          [
            65.5,
            65.5,
            65.5,
            65.5,
            65.5,
            65.5
          ],
          [
            50.5,
            47,
            49,
            50.5,
            50.5,
            50.5
          ],
          [
            53,
            48,
            42.5,
            45,
            45,
            45
          ]
        ]
      }
    },
    {
      "rel": "hyc-ele",
      "series": {
        "data": [
          [
            39.1771,
            29.4686,
            16.4515,
            5.7165,
            3.5397,
            1.5
          ],
          [
            48.2734,
            36.2668,
            23.943,
            15.6934,
            11.8358,
            9.567
          ],
          [
            59.1803,
            41.6113,
            20.0283,
            15.8089,
            12.4951,
            6.4716
          ],
          [
            23.2806,
            10.9588,
            2.5389,
            0.7268,
            0.3841,
            0.2971
          ],
          [
            45.3212,
            22.4125,
            4.7326,
            0.0636,
            0.0185,
            0.0122
          ]
        ],
        "r": [
          [
            14.5,
            14.5,
            14.5,
            14.5,
            14.5,
            14.5
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            57.5,
            57.5,
            57.5,
            57.5,
            57.5,
            57.5
          ],
          [
            47.5,
            47.5,
            47.5,
            47.5,
            47.5,
            47.5
          ],
          [
            24,
            24,
            24,
            24,
            24,
            24
          ],
          [
            59,
            59,
            59,
            59,
            59,
            59
          ],
          [
            14.5,
            14.5,
            14.5,
            14.5,
            14.5,
            14.5
          ]
        ]
      }
    },
    {
      "rel": "bio-tra",
      "series": {
        "data": [
          [
            1.0944,
            0.7248,
            0.5733,
            0.5297,
            0.4972,
            0.4341
          ],
          [
            8.6767,
            12.5366,
            15.939,
            19.1145,
            21.2326,
            23.7562
          ],
          [
            2.5612,
            6.9135,
            17.5048,
            22.5747,
            24.8969,
            27.3099
          ],
          [
            5.0761,
            7.2896,
            12.3593,
            17.6914,
            22.0557,
            25.1495
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            15.5,
            17.5,
            17.5,
            17.5,
            17.5,
            17.5
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            6.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ],
          [
            14.5,
            14.5,
            14.5,
            14.5,
            14.5,
            14.5
          ],
          [
            15.5,
            15.5,
            15.5,
            15.5,
            15.5,
            15.5
          ],
          [
            15.5,
            15.5,
            15.5,
            15.5,
            15.5,
            15.5
          ],
          [
            21,
            21,
            21,
            21,
            21,
            21
          ]
        ]
      }
    },
    {
      "rel": "bio-rnc",
      "series": {
        "data": [
          [
            27.7113,
            24.9812,
            23.4764,
            22.3218,
            20.2998,
            17.4292
          ],
          [
            36.7781,
            35.901,
            34.7524,
            33.3355,
            31.6278,
            29.8685
          ],
          [
            30.6958,
            29.4409,
            28.0734,
            26.7429,
            25.3959,
            24.0382
          ],
          [
            26.0655,
            21.5536,
            18.2537,
            14.3971,
            10.9445,
            8.1923
          ],
          [
            28.4815,
            22.3393,
            18.296,
            14.1445,
            10.4273,
            7.4402
          ]
        ],
        "r": [
          [
            18,
            18,
            18,
            18,
            18,
            18
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            13,
            13,
            13,
            13,
            13,
            13
          ],
          [
            25.5,
            25.5,
            25.5,
            25.5,
            25.5,
            25.5
          ],
          [
            33,
            33,
            33,
            33,
            33,
            33
          ],
          [
            32,
            32,
            32,
            32,
            32,
            32
          ],
          [
            24.5,
            24.5,
            24.5,
            24.5,
            24.5,
            24.5
          ]
        ]
      }
    },
    {
      "rel": "bio-ele",
      "series": {
        "data": [
          [
            8.3429,
            6.0868,
            1.5053,
            0.7505,
            0.6233,
            0.4254
          ],
          [
            3.3314,
            4.7259,
            6.4152,
            8.0713,
            9.5248,
            10.8154
          ],
          [
            1.4028,
            2.3962,
            8.2557,
            10.8453,
            9.8713,
            6.0929
          ],
          [
            1.0916,
            1.0161,
            0.8927,
            0.7042,
            0.4515,
            0.2085
          ],
          [
            1.2282,
            1.1527,
            1.029,
            0.8388,
            0.5822,
            0.3313
          ]
        ],
        "r": [
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            71.5,
            71.5,
            71.5,
            71.5,
            71.5,
            71.5
          ],
          [
            72,
            72,
            72,
            72,
            72,
            72
          ],
          [
            81.5,
            81.5,
            81.5,
            81.5,
            81.5,
            81.5
          ],
          [
            77,
            77,
            77,
            77,
            77,
            77
          ],
          [
            63,
            63,
            63,
            63,
            63,
            63
          ]
        ]
      }
    },
    {
      "rel": "bio-ind",
      "series": {
        "data": [
          [
            6.0896,
            5.8263,
            5.8339,
            6.6018,
            8.9693,
            12.0341
          ],
          [
            11.2023,
            12.7296,
            14.5554,
            16.4526,
            18.7323,
            20.7896
          ],
          [
            11.2125,
            11.9985,
            12.6855,
            13.745,
            14.8907,
            16.0949
          ],
          [
            26.3744,
            29.1901,
            26.8432,
            23.605,
            19.8099,
            15.8644
          ],
          [
            16.0855,
            19.1326,
            17.2701,
            14.4769,
            11.6997,
            9.2119
          ]
        ],
        "r": [
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            69.5,
            69.5,
            69.5,
            69.5,
            69.5,
            69.5
          ],
          [
            70,
            70,
            70,
            70,
            70,
            70
          ],
          [
            72.5,
            72.5,
            72.5,
            72.5,
            72.5,
            72.5
          ],
          [
            72,
            72,
            72,
            72,
            72,
            72
          ],
          [
            71.5,
            71.5,
            71.5,
            71.5,
            71.5,
            71.5
          ]
        ]
      }
    },
    {
      "rel": "ele-tra",
      "series": {
        "data": [
          [
            2.8093,
            5.1772,
            8.539,
            11.7966,
            14.5747,
            17.0468
          ],
          [
            2.6669,
            6.4464,
            12.4778,
            19.0654,
            25.1488,
            30.2489
          ],
          [
            2.821,
            4.704,
            8.943,
            10.3616,
            11.7175,
            13.0415
          ],
          [
            3.235,
            6.1621,
            10.5964,
            15.8234,
            20.531,
            24.1791
          ],
          [
            3.1013,
            6.8879,
            13.4483,
            20.0423,
            24.2184,
            26.9244
          ]
        ],
        "r": [
          [
            41,
            41,
            41,
            41,
            41,
            41
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            12,
            12,
            12,
            12,
            12,
            12
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            51,
            48.5,
            49,
            48,
            46.5,
            41
          ],
          [
            50.5,
            51,
            49,
            47,
            48,
            45
          ],
          [
            71.5,
            66.5,
            57.5,
            55,
            51.5,
            51.5
          ],
          [
            31.5,
            28.5,
            26,
            20.5,
            17.5,
            14.5
          ],
          [
            12.5,
            12.5,
            12.5,
            12.5,
            12.5,
            12.5
          ]
        ]
      }
    },
    {
      "rel": "ele-rnc",
      "series": {
        "data": [
          [
            37.6255,
            37.6243,
            38.9502,
            42.9097,
            48.6206,
            54.2094
          ],
          [
            45.0439,
            49.4234,
            54.3706,
            58.3346,
            61.5299,
            64.057
          ],
          [
            48.5356,
            61.2329,
            85.0193,
            94.1475,
            100.6018,
            106.5564
          ],
          [
            50.1024,
            65.4887,
            84.2186,
            106.6557,
            126.2909,
            142.4921
          ],
          [
            51.4907,
            61.7061,
            80.4857,
            105.567,
            128.1176,
            145.4293
          ]
        ],
        "r": [
          [
            35,
            35,
            35,
            35,
            35,
            35
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            58.5,
            58.5,
            58.5,
            58.5,
            57,
            54
          ],
          [
            60.5,
            60.5,
            60.5,
            60.5,
            63.5,
            60.5
          ],
          [
            81,
            78,
            72,
            70.5,
            69,
            69
          ],
          [
            41.5,
            41.5,
            41.5,
            41.5,
            41.5,
            41.5
          ],
          [
            38.5,
            38.5,
            38.5,
            38.5,
            38.5,
            38.5
          ]
        ]
      }
    },
    {
      "rel": "ele-ind",
      "series": {
        "data": [
          [
            34.953,
            35.4297,
            39.8715,
            46.489,
            52.7113,
            55.835
          ],
          [
            36.1386,
            37.6324,
            39.0275,
            40.6379,
            41.5577,
            42.3163
          ],
          [
            34.8186,
            43.3012,
            65.9052,
            70.1401,
            70.5843,
            70.8182
          ],
          [
            36.9265,
            48.0624,
            62.5129,
            78.3087,
            94.233,
            108.9379
          ],
          [
            42.663,
            51.7171,
            69.6137,
            96.3841,
            122.946,
            145.7369
          ]
        ],
        "r": [
          [
            40,
            40,
            40,
            40,
            40,
            40
          ],
          [
            15,
            20,
            15,
            20,
            15,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            5,
            10,
            5,
            10,
            5,
            10
          ]
        ],
        "turn": [
          [
            69,
            71,
            69.5,
            70.5,
            72,
            69.5
          ],
          [
            73,
            73,
            74.5,
            75,
            79,
            75.5
          ],
          [
            91,
            91,
            91,
            91,
            91,
            91
          ],
          [
            54.5,
            57.5,
            63,
            69,
            73.5,
            79
          ],
          [
            78.5,
            78.5,
            78.5,
            78.5,
            78.5,
            78.5
          ]
        ]
      }
    }
  ],
  "co2connectors": [
    {
      "rel": "una-atm",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            67.5,
            69.5,
            69,
            66,
            64.5,
            62
          ],
          [
            83.5,
            83.5,
            83.5,
            83.5,
            83.5,
            83.5
          ],
          [
            75.5,
            75.5,
            75.5,
            75.5,
            75.5,
            75.5
          ],
          [
            74.5,
            74.5,
            74.5,
            74.5,
            74.5,
            74.5
          ],
          [
            68.5,
            68.5,
            65,
            64.5,
            68.5,
            63
          ]
        ]
      }
    },
    {
      "rel": "una-cac",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            38.5,
            50,
            50,
            50,
            50,
            50
          ],
          [
            60.5,
            60.5,
            60.5,
            60.5,
            60.5,
            60.5
          ],
          [
            59.5,
            59.5,
            59.5,
            59.5,
            59.5,
            59.5
          ],
          [
            54.5,
            54.5,
            54.5,
            54.5,
            54.5,
            54.5
          ],
          [
            62.5,
            62.5,
            62.5,
            62.5,
            62.5,
            62.5
          ]
        ]
      }
    },
    {
      "rel": "tra-atm",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            57,
            61,
            62.5,
            60.5,
            59.5,
            57
          ],
          [
            68.5,
            68.5,
            68.5,
            68.5,
            68.5,
            68.5
          ],
          [
            66,
            66,
            66,
            66,
            66,
            66
          ],
          [
            63,
            63,
            63,
            63,
            63,
            63
          ],
          [
            56.5,
            56.5,
            56.5,
            56.5,
            56.5,
            56.5
          ]
        ]
      }
    },
    {
      "rel": "rnc-atm",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            40.5,
            46,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            44.5,
            46,
            45,
            50,
            49,
            50
          ],
          [
            39.5,
            42.5,
            45.5,
            48,
            39.5,
            49
          ]
        ]
      }
    },
    {
      "rel": "ind-atm",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            48.5,
            49,
            49,
            49,
            49,
            49
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "ele-atm",
      "type": "l",
      "side": {
        "from": "c",
        "to": "b"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            22,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "ind-cac",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            16.5,
            14
          ]
        ],
        "turn": [
          [
            31.5,
            37,
            37,
            37,
            37,
            37
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            8.5,
            8.5,
            8.5,
            8.5,
            8.5,
            8.5
          ],
          [
            50.5,
            45.5,
            35.5,
            30,
            33,
            27.5
          ]
        ]
      }
    },
    {
      "rel": "atm-pho",
      "type": "l",
      "side": {
        "from": "r",
        "to": "t"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            100,
            100,
            100,
            100,
            100,
            100
          ],
          [
            100,
            100,
            100,
            100,
            100,
            100
          ],
          [
            100,
            100,
            100,
            100,
            100,
            100
          ],
          [
            100,
            100,
            100,
            100,
            100,
            100
          ],
          [
            100,
            100,
            100,
            100,
            100,
            100
          ]
        ],
        "turn": [
          [
            48,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            48,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "pho-nas",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            40,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            39.5,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "nas-nes",
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            15,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            45,
            45,
            45,
            45,
            45,
            45
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            49,
            49,
            49,
            49,
            49,
            49
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "nas-bio",
      "type": "u",
      "side": {
        "from": "b",
        "to": "b"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            16.5,
            18.5,
            18.5,
            19.5,
            19,
            19.5
          ],
          [
            15,
            15,
            15,
            15,
            15,
            15
          ],
          [
            14,
            14,
            14,
            14,
            14,
            14
          ],
          [
            37,
            34.5,
            32,
            27,
            23.5,
            20.5
          ],
          [
            16,
            16,
            16,
            16,
            16,
            16
          ]
        ]
      }
    },
    {
      "rel": "nas-bwc",
      "type": "u",
      "side": {
        "from": "b",
        "to": "b"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            27.5,
            27.5,
            27.5,
            27.5,
            27.5,
            27.5
          ],
          [
            27,
            26.5,
            28,
            27.5,
            29,
            29
          ],
          [
            25.5,
            25.5,
            25.5,
            27,
            28,
            29.5
          ],
          [
            50,
            11,
            50,
            50,
            50,
            50
          ],
          [
            26,
            27,
            29.5,
            31,
            31.5,
            32
          ]
        ]
      }
    },
    {
      "rel": "atm-nta",
      "type": "s",
      "side": {
        "from": "l",
        "to": "r"
      },
      "showText": true,
      "ignoreWidth": true,
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            0,
            10,
            10
          ]
        ],
        "turn": [
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "cac-reu",
      "type": "u",
      "dottedOnlyIf0": true,
      "side": {
        "from": "t",
        "to": "t"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            30,
            30,
            30,
            30,
            30,
            30
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          [
            29.5,
            29.5,
            29.5,
            29.5,
            29.5,
            16.5
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ]
        ],
        "turn": [
          [
            9.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ],
          [
            9.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ],
          [
            7,
            7,
            7,
            7,
            7,
            7
          ],
          [
            9.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ]
      }
    },
    {
      "rel": "cac-geo",
      "type": "u",
      "dottedOnlyIf0": true,
      "side": {
        "from": "t",
        "to": "t"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            29.5,
            29.5,
            29.5,
            29.5,
            29.5,
            29.5
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          [
            29.5,
            29.5,
            29.5,
            29.5,
            29.5,
            14
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ]
        ],
        "turn": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            9.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ],
          [
            6.5,
            6.5,
            6.5,
            6.5,
            6.5,
            6.5
          ],
          [
            9.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ],
          [
            9.5,
            9.5,
            9.5,
            9.5,
            9.5,
            9.5
          ]
        ]
      }
    },
    {
      "rel": "dac-geo",
      "dottedOnlyIf0": true,
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            20,
            20,
            20,
            20,
            20,
            20
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "ele-cac",
      "type": "l",
      "side": {
        "from": "rc",
        "to": "b"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            51.5,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    },
    {
      "rel": "atm-dac",
      "type": "l",
      "dottedOnlyIf0": true,
      "side": {
        "from": "r",
        "to": "t"
      },
      "series": {
        "data": [
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          [
            0,
            0,
            0,
            0,
            0,
            0
          ]
        ],
        "r": [
          [
            22,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ],
          [
            10,
            10,
            10,
            10,
            10,
            10
          ]
        ],
        "turn": [
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ],
          [
            50,
            50,
            50,
            50,
            50,
            50
          ]
        ]
      }
    }
  ]
}
